import { render, staticRenderFns } from "./MenuItemTip.vue?vue&type=template&id=289bff62&scoped=true"
import script from "./MenuItemTip.vue?vue&type=script&lang=js"
export * from "./MenuItemTip.vue?vue&type=script&lang=js"
import style0 from "./MenuItemTip.vue?vue&type=style&index=0&id=289bff62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bff62",
  null
  
)

export default component.exports